import React from "react";

const Timeline = ({ steps, currentStep }) => {
  return (
    <ol className="flex-wrap sm:flex-nowrap rtds-flex rtds-items-center w-full text-sm font-medium text-center text-gray-500 dark:text-gray-400 sm:text-base">
      {steps.map((step, index) => (
        <li
          key={index}
          id={`tab-${index}`}
          className={`rtds-flex md:w-full items-center ${
            index !== steps.length - 1
              ? "after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-2 dark:after:border-gray-700"
              : ""
          } ${index === currentStep  ? "rtds-content-02 rtds-font-bold" : ""}`}
        >
          <span className="rtds-flex rtds-items-center after:content-['/'] sm:after:hidden after:mx-4 after:text-gray-200 dark:after:text-gray-500">
            {step.completed? (
              <svg
                className="rtds-icon rtds-w-10 rtds-h-10 rtds-mr-2"
                aria-hidden="true"
                focusable="false"
                role="img"
              >
                <use xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--check-circle`} />
              </svg>
            ) : (
              <span className="rtds-mr-2">{index + 1}</span>
            )}
            <span>{step.label}</span>
          </span>
        </li>
      ))}
    </ol>
  );
};

export default Timeline;
